/*
Fire Retardant Finishes
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Fire Retardant Finishes'
const id = 'cbm44Kf77p3h7Qi7sMZ0'

export default {
  name,
  id,
  filters,
  headers,
  form
}
